import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import { Modal } from 'antd';
import { Provider } from 'react-redux';
import ButtonIconGhostMedium from '../ButtonIconGhost/ButtonIconGhostMedium';
import { Icon } from '../../icon/icon';
import store from '../../../store/root.reducer';
import { cn } from '../../../utils/string/cn.utils';
import { Drawer } from 'antd';
import ButtonIconOutlineMedium from '../ButtonIconOutline/ButtonIconOutlineMedium';

let drawerInstance = null;

/**
 * Hàm mở drawer - có thể gọi từ bất kỳ đâu
 * @param {Object} config - Cấu hình drawer (title, content, onOk, onCancel, v.v.)
 * @returns {Object} Object chứa các method destroy và update
 */
export const openDrawer = config => {
  // Destroy drawer cũ nếu tồn tại
  if (drawerInstance) {
    drawerInstance.destroy();
  }

  const div = document.createElement('div');
  document.body.appendChild(div);

  const root = ReactDOM.createRoot(div);
  let currentConfig = config;

  const destroy = () => {
    if (currentConfig?.afterClose) {
      currentConfig.afterClose();
    }
    root.unmount();
    if (div.parentNode) {
      div.parentNode.removeChild(div);
    }
    drawerInstance = null;
  };

  const render = props => {
    const { content, title, closable, classNames, onClose, ...restProps } =
      props;

    root.render(
      <Provider store={store}>
        {
          <RenderDrawer
            content={content}
            title={title}
            closable={closable}
            classNames={classNames}
            onClose={onClose}
            destroy={destroy}
            {...restProps}
          />
        }
      </Provider>
    );
  };

  render(config);

  drawerInstance = {
    destroy,
    update: newConfig => {
      render({ ...config, ...newConfig });
    },
  };

  return drawerInstance;
};

const RenderDrawer = ({
  content,
  // title,
  // closable,
  // classNames,
  onClose,
  destroy,
  ...restProps
}) => {
  const [open, setOpen] = useState(true);

  return (
    <Drawer
      open={open}
      {...restProps}
      // classNames={{
      //   header: cn(
      //     'p-[24px] flex items-center gap-[24px] self-stretch',
      //     classNames?.header
      //   ),
      //   body: cn(
      //     'flex p-[16px] pb-[8px] flex-col gap-[16px] items-start self-stretch grow bg-[#F5F5F5]',
      //     classNames?.body
      //   ),
      //   content: cn('rounded-l-[16px]', classNames?.content),
      //   footer: cn('!p-0', classNames?.footer),
      // }}
      // closable={false}
      onClose={() => {
        setOpen(false);
        setTimeout(() => {
          onClose?.();
          destroy();
        }, 300);
      }}
      // title={
      //   <>
      //     {closable !== false && (
      //       <ButtonIconOutlineMedium
      //         icon={<Icon.ICClose />}
      //         onClick={() => {
      //           setOpen(false);
      //           setTimeout(() => {
      //             onClose?.();
      //             destroy();
      //           }, 300);
      //         }}
      //         className={cn('', classNames.iconClose)}
      //       />
      //     )}
      //     <span className="text-title-large">{title}</span>
      //   </>
      // }
    >
      {content}
    </Drawer>
  );
};
